import type { SocialImageOrientation } from '@pulsify/shared/dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { imageApi } from '../api'

interface GenerateImageVars {
  prompt: string
  orientation: SocialImageOrientation
  purpose?: 'event-cover'
}

export function useGenerateImage(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ prompt, orientation, purpose }: GenerateImageVars) =>
      imageApi.generate(businessId, prompt, orientation, purpose),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
